import React from "react";
import { Box, Button, Tooltip } from "@mui/material";

export interface RelatedBadge {
  count: number;
  href: string;
  tooltip: string;
}

const BUTTON_SX = {
  minWidth: 0,
  px: 0.75,
  py: 0,
  lineHeight: 1.6,
  whiteSpace: "nowrap",
} as const;

// Keep clicks from selecting the row or starting an edit
const stopPropagation = (event: React.SyntheticEvent) =>
  event.stopPropagation();

function Badge({ symbol, badge }: { symbol: string; badge: RelatedBadge }) {
  return (
    <Tooltip title={badge.tooltip}>
      <Button
        size="small"
        variant="outlined"
        href={badge.href}
        target="_blank"
        rel="noreferrer"
        onClick={stopPropagation}
        onDoubleClick={stopPropagation}
        sx={BUTTON_SX}
      >
        {symbol} {badge.count}
      </Button>
    </Tooltip>
  );
}

// Equal (=) and Shared (≋) badges for the Pricetool Related columns. Both are
// always shown, including at 0, since an empty result is itself informative.
export function RelatedBadges({
  equal,
  shared,
}: {
  equal: RelatedBadge;
  shared: RelatedBadge;
}) {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 0.5, height: "100%" }}
    >
      <Badge symbol="=" badge={equal} />
      <Badge symbol="≋" badge={shared} />
    </Box>
  );
}
